/**
 * Portfolio API 서비스
 */
import { PortfolioResponse } from '../types/portfolio';
import { API_BASE_URL } from '../config';
import { apiFetch } from '../utils/apiFetch';

/**
 * 포트폴리오 조회
 *
 * @returns Promise<PortfolioResponse> - 계좌 정보 + 포지션 목록
 * @throws Error - API 호출 실패 시
 */
export async function fetchPortfolio(): Promise<PortfolioResponse> {
  const response = await apiFetch(`${API_BASE_URL}/api/portfolio`);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.detail || `API 오류: ${response.status} ${response.statusText}`
    );
  }

  return response.json();
}
